const namespace = {
  title: "Données démographiques locales",
  note: "Affichage des données démographiques pour la zone située à {{value}} {{unit}} autour de l'emplacement sélectionné.",
  noData:
    "Aucune donnée démographique n'est disponible pour cet endroit particulier.",
  data: {
    income: {
      title: "Revenu",
      graphs: {
        averageIncome: {
          title: "Revenu moyen",
          title_USA: "Revenu médian",
          types: {
            avgHouseholdIncome: "Familial",
            avgHouseholdIncome_USA: "Ménage (médian)",
            avgIndividualIncome: "Individuel",
            avgIndividualIncome_USA: "Individuel (par habitant)",
          },
        },
        employment: {
          title: "Emploi",
        },
        incomeBrackets: {
          title: "Tranches de revenu",
        },
      },
    },
    population: {
      title: "Population",
      graphs: {
        totalPopulation: {
          title: "Population totale",
        },
        populationByAgeGroup: {
          title: "Population par tranche d'âge",
        },
      },
    },
    housing: {
      title: "Logement",
      graphs: {
        homeOwnershipType: {
          title: "Propriétaires c. locataires",
        },
        typeOfHousing: {
          title: "Type de logement",
        },
      },
    },
    household: {
      title: "Ménages",
      graphs: {
        householdComposition: {
          title: "Composition des ménages",
        },
      },
    },
    education: {
      title: "Éducation",
      graphs: {
        educationLevel: {
          title: "Niveau d'études atteint",
        },
      },
    },
    commute: {
      title: "Transport",
      graphs: {
        commuteMode: {
          title: "Modes de transport",
        },
      },
    },
    languages: {
      title: "Langues",
      graphs: {
        spokenLanguages: {
          title: "Langues officielles parlées",
        },
        motherTongue: {
          title: "Langue maternelle",
        },
      },
    },
  },
} as const;

export default namespace;
